import { useState } from "react"
import { useGlobalAlert } from "contexts/GlobalAlertContext"
import { studentRequest } from "services/requests"
const prefix = "independentWork"

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { showAlert } = useGlobalAlert()

  const getIndependentWork = async ({ missionModuleId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}?missionModuleId=${missionModuleId}`,
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response
  }

  const addTeam = async ({ independentWorkId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/AddTeam?independentWorkId=${independentWorkId}`,
      body: null,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const setTeamActive = async ({ independentWorkId, teamId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/setTeamActive?independentWorkId=${independentWorkId}&teamId=${teamId}`,
      body: null,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const getTeamMembers = async ({ groupdId, independentWorkId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/teamMembers?groupId=${groupdId}&independentWorkId=${independentWorkId}`,
      body: null,
      method: "get",
    })
    setIsFetching(false)
    if (!response.success) {
      showAlert(response.message)
      return []
    }
    return response?.data?.teamMembers || []
  }

  const addTeamMember = async ({ independentWorkId, teamId, userId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/addTeamMember?independentWorkId=${independentWorkId}&teamId=${teamId}&userId=${userId}`,
      body: null,
      method: "post",
    })
    setIsFetching(false)
    return response?.data || { status: false }
  }

  const removeTeamMember = async ({ independentWorkId, teamId, userId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/removeTeamMember?independentWorkId=${independentWorkId}&teamId=${teamId}&userId=${userId}`,
      body: null,
      method: "post",
    })
    setIsFetching(false)
    return response?.data || { status: false }
  }

  return {
    getIndependentWork,
    addTeam,
    setTeamActive,
    getTeamMembers,
    addTeamMember,
    removeTeamMember,
    isFetching,
  }
}

export default useApi
